/**
 * chime — short, soft two-note sine chime via the Web Audio API (no asset).
 * Failure-tolerant: autoplay policy or a missing AudioContext just means
 * silence, never an error.
 */

export function playChime(): void {
  try {
    const Ctx =
      window.AudioContext ??
      (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const t0 = ctx.currentTime;
    // E5 then A5, each a quick attack with an exponential tail.
    [659.25, 880].forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      const at = t0 + i * 0.28;
      gain.gain.setValueAtTime(0.0001, at);
      gain.gain.exponentialRampToValueAtTime(0.18, at + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, at + 0.9);
      osc.connect(gain).connect(ctx.destination);
      osc.start(at);
      osc.stop(at + 0.95);
    });
    window.setTimeout(() => void ctx.close().catch(() => undefined), 1800);
  } catch {
    /* audio is best-effort */
  }
}
